import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from '../../common/withRouter';
import {
  DataDefinitionList,
  Loader,
  Notification,
  Message,
  ButtonOBSOLETED
} from '../../web.common';
import AriaModal from 'react-aria-modal';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';
import {
  DisplayDate,
  DisplayGuid,
  DisplayStatus,
  DisplayPrice,
  DisplayDateRange,
  DisplayPaymentMethod
} from '../items';
import { DetailsRightBar, Link, Divider, Action } from './DetailsRightBar';
import { subscriptionStatus } from '../../enums/subscriptionStatus';

class SubscriptionInternal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscriptionData: null
    };
  }

  async componentDidMount() {
    const { match: { params: { subscriptionId } } } = this.props;
    const { api: { subscriptions: { getSubscription, isRegrettable } } } = this.props;

    try {
      const subscriptionData = await getSubscription(subscriptionId);
      this.setState({ subscriptionData });
    }
    catch (e) {
      this.setState({ errorMessage: new Message('error', 'Unable to get data') });
    }

    setTimeout(async () => {
      try {
        var { IsRegrettable } = await isRegrettable(subscriptionId);

        console.log('IsRegrettable 3', JSON.stringify(IsRegrettable));
        this.setState({ isRegrettable: IsRegrettable });
      }
      catch (e) {
        this.setState({ isRegrettable: false });
      }
    });
  }

  displayPaymentPlan(PaymentPlan) {
    if (!PaymentPlan) {
      return '';
    }
    return (
      <React.Fragment>
        {PaymentPlan.map(x => {
          const start = x.BillingPeriodStart.replace('T00:00:00', '');
          const end = x.BillingPeriodEnd.replace('T00:00:00', '');
          const discount = x.Discount || 'n.d.';
          const price = x.FixedAmount || 'n.d.';
          const text = `${start} - ${end} Discount: ${discount} Price: ${price}`;

          return (<div>{text}</div>);
        })}
      </React.Fragment>
    );
  }

  render() {
    const { match: { params: { subscriptionId } } } = this.props;
    const { subscriptionData, errorMessage, isConfirming, isRegrettable, isPerformingAction } = this.state;
    let mappedData = null;
    const MembershipLogicType = subscriptionData && subscriptionData.MembershipLogicType;

    if (subscriptionData) {
      const {
        Id,
        MembershipId,
        PaymentMethod,
        Reference,
        ExternalReference,
        Status,
        Text,
        UserId,
        UpdatedAt,
        CreatedAtCet,
        BillingPeriodStartsAt,
        BillingPeriodEndsAt,
        BucketPeriodStartsAt,
        BucketPeriodEndsAt,
        TerminationPeriodEndsAt,
        TerminationPeriodStartsAt,
        NextBillingAt,
        DiscountExpireAt,
        PaidThroughAt,
        TerminatedAt,
        Price,
        SuspendedTo,
        SuspendedFrom,
        LastRegretAt,
        PreferredClub,
        PaymentPlan
      } = subscriptionData;


      mappedData = {
        Id: <DisplayGuid>{Id}</DisplayGuid>,
        UserId: <DisplayGuid baseAnchor='/user'>{UserId}</DisplayGuid>,
        'Membership Id': <DisplayGuid baseAnchor='/product'>{MembershipId}</DisplayGuid>,
        Price: <DisplayPrice details='hover'>{Price}</DisplayPrice>,
        Status: <DisplayStatus mapping={subscriptionStatus}>{Status}</DisplayStatus>,
        Text: Text || '',
        Reference: Reference || '',
        'Payment Method':
  <Link to={`/paymentmethod/${subscriptionData.PaymentMethod.Type}/${subscriptionData.PaymentMethodId}`}>
    <DisplayPaymentMethod>{PaymentMethod}</DisplayPaymentMethod>
  </Link>,
        'Created At (CET)': <DisplayDate>{CreatedAtCet}</DisplayDate>,
        'External Reference': ExternalReference || '',
        'Next Billing At': <DisplayDate>{NextBillingAt}</DisplayDate>,
        'Billing Period': <DisplayDateRange>{[BillingPeriodStartsAt, BillingPeriodEndsAt]}</DisplayDateRange>,
        'Termination Period': <DisplayDateRange>{[TerminationPeriodStartsAt, TerminationPeriodEndsAt]}</DisplayDateRange>,
        'Bucket Period': <DisplayDateRange>{[BucketPeriodStartsAt, BucketPeriodEndsAt]}</DisplayDateRange>,
        'Paid Through At': <DisplayDate>{PaidThroughAt}</DisplayDate>,
        'Terminated At': <DisplayDate>{TerminatedAt}</DisplayDate>,
        'Updated At': <DisplayDate>{UpdatedAt}</DisplayDate>,
        'Discount Expire At': <DisplayDate>{DiscountExpireAt}</DisplayDate>,
        'Suspended To': <DisplayDate>{SuspendedTo}</DisplayDate>,
        'Suspended From': <DisplayDate>{SuspendedFrom}</DisplayDate>,
        'Last Regret At': <DisplayDate>{LastRegretAt}</DisplayDate>,
        'Preferred Club': <DisplayGuid baseAnchor='/facility'>{PreferredClub}</DisplayGuid>,
        'Payment Plan': this.displayPaymentPlan(PaymentPlan)
      };
    }

    return (
      <LayoutContext.Consumer>
        {() => (
          <React.Fragment>
            {
              isConfirming ? (
                // TODO: extract modal
                <AriaModal
                  titleText='Confirm action'
                  mounted
                  verticallyCenter={false}
                  focusDialog
                  getApplicationNode={() => document.getElementById('app')}
                  dialogClass='dialog-size-normal'
                  scrollDisabled
                >
                  <h3>Are you sure you want to proceed?</h3>

                  {
                    isConfirming === 'force-termination'
                      ? (
                        <p>
                          <span role='img' aria-label='warning'>⚠️</span>
                          {' '}
                          User will
                          <b>not</b>
                          {' '}
                          get a refund. This option should be used only if regret is not available!
                        </p>
                      )
                      : ''
                  }

                  <ButtonOBSOLETED
                    disabled={isPerformingAction}
                    buttonColor='danger'
                    size='small'
                    onClick={async () => {
                      const {
                        api: {
                          subscriptions: {
                            cancelSubscription,
                            regretSubscription,
                            charge,
                            getSubscription,
                            suspendSubscription,
                            resumeSubscription,
                            forceTermination
                          }
                        }
                      } = this.props;

                      this.setState({
                        isConfirming: false,
                        subscriptionData: null
                      });

                      try {
                        this.setState({ isPerformingAction: true });
                        if (isConfirming === 'regret') {
                          await regretSubscription(subscriptionId);
                        }
                        else if (isConfirming === 'cancel') {
                          await cancelSubscription(subscriptionId);
                        }
                        else if (isConfirming === 'resume') {
                          await resumeSubscription(subscriptionId);
                        }
                        else if (isConfirming === 'suspend') {
                          await suspendSubscription(subscriptionId);
                        }
                        else if (isConfirming === 'force-termination') {
                          await forceTermination(subscriptionId);
                        }
                        else if (isConfirming === 'charge') {
                          await charge(subscriptionId);
                        }
                      }
                      catch (e) {
                        this.setState({
                          errorMessage: new Message('error', `Unable to perform action: ${e}`)
                        });
                      }
                      this.setState({ isPerformingAction: false });
                      try {
                        const newSubscriptionData = await getSubscription(subscriptionId);
                        this.setState({
                          isConfirming: false,
                          subscriptionData: newSubscriptionData
                        });
                      }
                      catch (e) {
                        this.setState({
                          errorMessage: new Message('error', `Unable to get data: ${e}`)
                        });
                      }
                    }}
                    buttonContent='Confirm'
                    ariaLabel='confirm'
                  >
                    Proceed
                  </ButtonOBSOLETED>
                  <br />
                  <ButtonOBSOLETED
                    buttonColor='gray'
                    size='small'
                    onClick={() => {
                      this.setState({ isConfirming: false });
                    }}
                    disabled={false}
                    buttonContent='Back'
                    ariaLabel='back'
                  >
                    Back
                  </ButtonOBSOLETED>
                </AriaModal>
              ) : ''
            }
            <Notification newMessage={errorMessage} />

            <div className='content-with-right-pane-delimiter'>
              <PageTop
                documentTitle='Subscription details'
                documentDescription='Subscription details'
              />

              <h2 className='main-page-header main-page-header-with-subheader'>
                Subscription
              </h2>
              <h5 className='main-page-subheader'>{subscriptionId}</h5>
              <br />

              {
                mappedData ? (
                  <React.Fragment>
                    <DataDefinitionList
                      listData={mappedData}
                      classNames={['detail-page-list']}
                    />
                  </React.Fragment>
                ) : <Loader hasLoaded={false}>Loading...</Loader>
              }
            </div>

            <DetailsRightBar>
              {
                mappedData ? (
                  <React.Fragment>
                    <Divider>Links</Divider>
                    <Link to={`/transactions?subscriptionId=${subscriptionData.Id}`}>Transactions</Link>
                    <Link to={`/user/${subscriptionData.UserId}`}>User</Link>
                    <Link
                      to={`/paymentmethod/${subscriptionData.PaymentMethod.Type}/${subscriptionData.PaymentMethodId}`}
                    >
                      Payment Method
                    </Link>
                    <Link to={`/product/details/${subscriptionData.MembershipId}`}>Membership</Link>
                    {
                        MembershipLogicType === 'SeasonalSlots' || MembershipLogicType === 'SeasonalSlotsPreSales'
                          ? (
                            <Link to={`/seasonalcourtpurchases?subscriptionId=${subscriptionData.Id}`}>
                              Seasonal Slot Purchases
                            </Link>
                          )
                          : ''
                    }

                    <Divider>Actions</Divider>
                    {isRegrettable
                      ? (
                        <Action action={() => {
                          this.setState({ isConfirming: 'regret' });
                        }}
                        >
                          Regret
                        </Action>
                      )
                      : <Action disabled action={() => { }}>Regret</Action>}
                    {subscriptionData.Status === 'Active'
                      ? (
                        <Action action={() => {
                          this.setState({ isConfirming: 'cancel' });
                        }}
                        >
                          Cancel
                        </Action>
                      )
                      : <Action disabled action={() => { }}>Cancel</Action>}
                    {subscriptionData.Status === 'Active'
                      ? (
                        <Action action={() => {
                          this.setState({ isConfirming: 'suspend' });
                        }}
                        >
                          Suspend
                        </Action>
                      )
                      : <Action disabled action={() => { }}>Suspend</Action>}
                    {subscriptionData.Status === 'Suspended' && !subscriptionData.SuspendedTo
                      ? (
                        <Action action={() => {
                          this.setState({ isConfirming: 'resume' });
                        }}
                        >
                          Resume
                        </Action>
                      )
                      : <Action disabled action={() => { }}>Resume</Action>}
                    {subscriptionData.Status !== 'Terminated'
                      ? (
                        <Action action={() => {
                          this.setState({ isConfirming: 'force-termination' });
                        }}
                        >
                          Force Termination
                        </Action>
                      )
                      : <Action disabled action={() => { }}>Force Termination</Action>}
                    {subscriptionData.Status === 'Active'
                      ? (
                        <Action action={() => {
                          this.setState({ isConfirming: 'charge' });
                        }}
                        >
                          Charge
                        </Action>
                      )
                      : <Action disabled action={() => { }}>Charge</Action>}
                  </React.Fragment>
                ) : ''
              }
            </DetailsRightBar>
          </React.Fragment>
        )}
      </LayoutContext.Consumer>
    );
  }
}

const Subscription = withRouter(
  withApi(
    connect(({ subscription }) => ({ isLoggedIn: !!subscription }), {})(SubscriptionInternal)
  )
);

Subscription.requiresLogin = true;
Subscription.propTypes = { isLoggedIn: PropTypes.bool };

export default Subscription;
